<template>
    <div style="text-align: center" class="container">
        <vue-qr :text="payUrl" :callback="test" qid="testid"></vue-qr>
        <div style="color: #666;font-size: 5vw">{{cateText[cate]}}</div>
        <div><a @click="go()" class="btn">返回缴费页</a></div>
    </div>
</template>

<script>
    import wxpay from '../utils/wxpay'
    import {getJsSdkConfig, pay} from "../api/api";
    import request from '../utils/request'
    import {xqPay} from "../pay";
    import VueQr from 'vue-qr'

    export default {
        name: "Pay"
        , components: {VueQr}
        , data() {
            return {
                payUrl: '',
                cate:'',
                cateText:{wx:'支付中...',ali:'长按保存二维码->前往支付宝扫一扫->打开相册选择二维码进行支付',ispay:'缴费成功'}
            }
        }, methods: {
            test() {

            },go(){

                this.$router.push({
                    path:'/fee'
                })

            }

        }, created() {


            // console.log();

            this.cate = this.$route.query.cate;

            pay(this.$route.query.id, location.href, this.$route.query.cate).then(res => {



                if (this.cate==='ali') {
                    if (res.data.err_code==0) {
                        this.payUrl = res.data.body.code_url;
                    }
                }


                if (this.cate==='wx') {

                    location.href='https://open.xiangqianpos.com/appWeb/payWeb?'+res.data;

                }

                // xqPay(res.data);


            }).catch(err=>{

                // console.log();

                if (err.response.data.errorCode===10000) {
                    this.$router.push({
                        path:'/fee'
                    })
                }


            });
            // pay()

            // getJsSdkConfig().then(res=>{
            //
            // });
            // wxpay();

        }, mounted() {


        }
    }
</script>

<style scoped>

    .container {
        text-align: center;
        position: absolute;
        top: 50%;
        margin-top: -50%;
        bottom: 0;
        left: 0;
        right: 0;
        padding: 0 5vw;
    }

    .btn {
        display: inline-block;
        width: 50%;
        padding: 2vw 2vw;
        background-color: #3e94ff;
        border-radius: 5px;
        color: #fff;
        margin-top: 5vw;
    }



</style>